import FeatureTogglesService from '@/services/FeatureToggles.service';
import { useQuery } from '@tanstack/react-query';

export function useGetFeatureToggles(sponsorPlanId?: number) {
  return useQuery(
    [`FeatureTogglesService.get.${sponsorPlanId}`],
    () => FeatureTogglesService.get(sponsorPlanId),
    {
      enabled: Boolean(sponsorPlanId)
    }
  );
}
